// Import types
import type { SubscriberDetails } from 'types/api/subscriber';
import type { Packet } from 'types/api/products/packets';

// Import helpers
import { getUserToken } from 'helpers/auth';

const token = getUserToken();

type State = {
	details: SubscriberDetails | null;
	isLoading: boolean;
	isError: boolean;
	token: string | null;
	packets: {
		data: Packet[];
		isLoading: boolean;
		isError: boolean;
	};
	products: {
		data: string[];
		isLoading: boolean;
		isError: boolean;
	};
};

export const initialState: State = {
	details: null,
	isLoading: Boolean(token),
	isError: false,
	token,
	packets: {
		data: [],
		isLoading: true,
		isError: false
	},
	products: {
		data: [],
		isLoading: true,
		isError: false
	}
};
